export default __webpack_public_path__ + "static/media/groupGym.27d28f22.jpg";